import { render, staticRenderFns } from "./CommonDiagnosisForm.vue?vue&type=template&id=2aac67fe&scoped=true&"
import script from "./CommonDiagnosisForm.vue?vue&type=script&lang=js&"
export * from "./CommonDiagnosisForm.vue?vue&type=script&lang=js&"
import style0 from "./CommonDiagnosisForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CommonDiagnosisForm.vue?vue&type=style&index=1&id=2aac67fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aac67fe",
  null
  
)

export default component.exports